import React from "react";
import "./PlanCard.scss";

export default function PlanCard({ plan }) {
  const {
    title,
    subtitle,
    priceAmount,
    priceCadence,
    firstMonthCopy,
    ongoingCopy,
    bucket,
    bullets,
    cta,
    featured,
    badgeText,
  } = plan;

  return (
    <article
      className={[
        "pcard",
        featured ? "is-featured" : "",
        cta?.variant ? `v-${cta.variant}` : "",
      ]
        .join(" ")
        .trim()}
    >
      {featured && (
        <span className="pcard__badge">{badgeText || "Most popular"}</span>
      )}

      <h3 className="pcard__title">{title}</h3>
      <p className="pcard__subtitle">{subtitle}</p>

      <div className="pcard__price-row">
        <span className="pcard__price">{priceAmount}</span>
        <span className="pcard__cadence">{priceCadence}</span>
      </div>

      <div className="pcard__notes">
        {firstMonthCopy && <p className="pcard__note">{firstMonthCopy}</p>}
        {ongoingCopy && <p className="pcard__note">{ongoingCopy}</p>}
      </div>

      <button
        type="button"
        className="pcard__cta"
        onClick={() => {
          window.open("https://tally.so/r/0Q5Mj6", "_blank", "noopener,noreferrer");
        }}
      >
        {cta?.label}
      </button>

      <h4 className="pcard__bucket">{bucket}</h4>
      <ul className="pcard__list">
        {bullets.map((bullet, i) => (
          <li key={i}>{bullet}</li>
        ))}
      </ul>
    </article>
  );
}